import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import PortalLayout from '../../components/portal/PortalLayout';
import { adminApi, clearPortalTokens } from '../../lib/http';

const items = [
  { label: 'Dashboard', href: '/admin/dashboard' },
  { label: 'Bookings', href: '/admin/bookings' },
  { label: 'Manual Booking', href: '/admin/manual-booking' },
  { label: 'Availability', href: '/admin/availability' },
  { label: 'Staff Management', href: '/admin/staff-management' },
  { label: 'Scanner', href: '/admin/scanner' },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  async function logout() {
    try {
      await adminApi.post('/admin/auth/logout');
    } finally {
      clearPortalTokens('admin');
      navigate('/admin/login', { replace: true });
    }
  }

  return (
    <PortalLayout
      title="Admin Panel"
      subtitle=""
      items={items}
      onLogout={logout}
    >
      <Outlet />
    </PortalLayout>
  );
}
